import React, { useState } from 'react'
import { LrTrackCommonControls } from '../../../lrSearch/lrTrackControls'
import Modal from '../../../common/modal'
import { Tab, Tabs } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { mainTabIds, pcTabIds } from '../../../common/constants'
import PersonIcon from '@mui/icons-material/Person'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import EmailIcon from '@mui/icons-material/Email'
import DropDown from '../../../common/dropDown'
import { Item } from '../../../common/snippets'
import { AllPaymentList } from '../../../common/paymentsMode'
import { LrTrackCard } from '../../../lrSearch/lrTrackCard'
import { STA_COMPANY_ID } from '../../../../helper/companyIdhardcode'

const LRStatusPopUp = (props) => {
  const { selectLr, updateModal, lrInfo, LrTrackData, loginData } = props
  const [searchParams, setSearchParams] = useSearchParams()
  const [activeTab, setActiveTab] = useState(0); // 0 for 'LR DETAILS', 1 for 'LR TRACKING'
  const [tabNumber, setTabNumber] = useState(searchParams.get('tab') || 0)
  const [lrTabValue, setLrTabValue] = useState(parseInt(tabNumber))
  const [csTab, setCsTab] = useState(searchParams.get('cstab') || 0)
  const [pcTabValue, setPcTabValue] = useState(parseInt(csTab))
  const firstStatus = LrTrackData ? LrTrackData?.[0] : false
  const lastStatus = LrTrackData ? LrTrackData[LrTrackData.length - 1] : false
  const showSenIdDrop = lrInfo?.SenderIDProof || lrInfo?.SenderIDProofNo || firstStatus?.IDProofImageURL || false
  const showsenImage = firstStatus?.SenderImageURL || false
  const showRecIdDrop = lrInfo?.ReceiverIDProof || lrInfo?.ReceiverIDProofNo || lastStatus?.IDProofImageURL || false
  const showRecImage = lastStatus?.SenderImageURL || false
  let { EWayBillNo = '', ExemptedGoods = '' } = lrInfo || {}

  const tablabels = ['LR DETAILS', 'LR TRACKING'];
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab, pcTab) => {
    params.tab = lrTab
    params.cstab = pcTab
    setSearchParams(params)
  }
  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  return (
    <Modal
      headTxt={tablabels[lrTabValue]}
      headText2={'LR Number: ' + selectLr?.LRNO}
      width={'25%'}
      height={'100%'}
      updateModal={() => updateModal()}
      modalClass="model--container-right"
    // onCloseCallback={handleCancel}
    >
      <>
        <Tabs
          sx={{ borderBottom: 1, borderColor: 'divider', background: '#fff' }}
          value={lrTabValue}
          onChange={(e, newValue) => {
            goToTabs(newValue, pcTabValue)
            setLrTabValue(parseInt(newValue))
          }}
          className="lrtrack-tabs"
          aria-label="tabs for lr details and lr tracking"
        >
          <Tab label={tablabels[0]} sx={{ width: '50%' }} aria-label="basic tabs example" {...mainTabIds(0)} />
          <Tab label={tablabels[1]} sx={{ width: '50%' }} aria-label="basic tabs example" {...mainTabIds(1)} />
        </Tabs>
        <div
          role="tabpanel"
          hidden={lrTabValue !== 0}
          id={`main-tabpanel-0`}
          aria-labelledby={`main-tab-0`}
          className="tab-main-1 detailed-tabs"
          style={{ height: 'calc(100% - 260px)', overflowX: 'auto' }}
        >
          <div className="tablayout tab-secondary">
            <Tabs
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              value={pcTabValue}
              onChange={(e, newValue) => {
                goToTabs(lrTabValue, newValue)
                setPcTabValue(parseInt(newValue))
              }}
              className="lrtrack-tabs"
              aria-label="tabs for payee and consignment details"
            >
              <Tab label="PAYEE DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...pcTabIds(0)} />
              <Tab label="CONSIGNMENT DETAILS" sx={{ width: '50%' }} aria-label="basic tabs example" {...pcTabIds(1)} />
            </Tabs>
          </div>
          <div
            role="tabpanel"
            hidden={pcTabValue !== 0}
            id={`pc-tabpanel-0`}
            aria-labelledby={`pc-tab-0`}
            className="tab-pc-1 detailed-tabs tab1-view"
          >
            <div className="source-details">
              <div className="heading-tab">Source: {lrInfo?.FromCity}</div>
              <div className="tab-details">Branch: {lrInfo?.BkgBranchName}</div>
              <div className="tab-details">
                <PersonIcon />
                Sender Name:{lrInfo?.Sender}
              </div>
              <div className="tab-details">
                <LocalPhoneIcon />
                Sender No:{lrInfo?.SenderMobileNo}
              </div>
              {lrInfo?.SenderEmailID != '' && (
                <div className="tab-details">
                  <EmailIcon />
                  Sender Email: {lrInfo?.SenderEmailID}
                </div>
              )}

              {lrInfo?.SenderGSTN != '' && (
                <div className="tab-details">
                  <CurrencyRupeeIcon />
                  Sender GSTN:{lrInfo?.SenderGSTN}
                </div>
              )}
              {showSenIdDrop && (
                <Item sx={{ width: '100%' }}>
                  <DropDown
                    disabled={false}
                    type="file"
                    //defaultvalue={lrInfo?.SenderIDProof + `${lrInfo?.SenderIDProofNo ?}`}
                    defaultvalue={`${lrInfo?.SenderIDProof || 'No ID Type'} | ${lrInfo?.SenderIDProofNo || 'No Id Number'}`}
                    data={[]}
                    actnTxt={`Show`}
                    showActn={true}
                  // onClick={setPopupIdDetails}
                  />
                </Item>
              )}
              {showsenImage && (
                <Item sx={{ width: '100%' }}>
                  <p
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      maxWidth: '800px',
                      fontSize: '13px',
                      color: 'black',
                      margin: '0px',
                    }}
                  >
                    <span>Sender Image:</span>
                    <img
                      // src={firstStatus.SenderImageURL}
                      width="100px"
                      height="66px"
                      style={{
                        height: '50px',
                        width: '50px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        margin: '0px 10px',
                      }}
                      border="0"
                    />

                    <a
                      href=""
                      id="idImageViewLink"
                      // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                      className="thumbnail blue-color-txt"
                      onClick={(e) => {
                        e.preventDefault()
                        // showImagePreviewPopup(true)
                      }}
                    >
                      Show
                      <span>
                        <img className={'right'} src={firstStatus.SenderImageURL} />
                      </span>
                    </a>
                  </p>
                </Item>
              )}
            </div>
            <div className="destination-details">
                  <div className="heading-tab">Destination: {lrInfo?.ToCity}</div>
                  <div className="tab-details">Branch: {lrInfo?.DestinationBranch}</div>
                  <div className="tab-details">
                    <PersonIcon />
                    Receiver Name: {lrInfo?.RecName}
                  </div>
                  <div className="tab-details">
                    <LocalPhoneIcon /> Receiver No: {lrInfo?.RecMobileNo}
                  </div>
                  {lrInfo?.ReceiverEmailID != '' && (
                    <div className="tab-details">
                      <EmailIcon />
                      Receiver Email: {lrInfo?.ReceiverEmailID}
                    </div>
                  )}
                  {lrInfo?.ReceiverGSTN != '' && (
                    <div className="tab-details">
                      <CurrencyRupeeIcon />
                      Receiver GSTN:{lrInfo?.ReceiverGSTN}
                    </div>
                  )}
  
                  {lastStatus.TYPE === 'F' && showRecIdDrop && (
                    <Item sx={{ width: '100%' }}>
                      <DropDown
                        disabled={false}
                        type="file"
                        defaultvalue={`${lrInfo?.ReceiverIDProof || 'No ID Type'} | ${lrInfo?.ReceiverIDProofNo || 'No Id Number'}`}
                        data={[]}
                        actnTxt={`Show`}
                        showActn={true}
                        onClick={() => {
                          // setPopupIdDetails(false)
                        }}
                      />
                    </Item>
                  )}
                  {lastStatus.TYPE === 'F' && showRecImage && (
                    <Item sx={{ width: '100%' }}>
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          maxWidth: '800px',
                          fontSize: '13px',
                          color: 'black',
                          margin: '0px',
                        }}
                      >
                        <span>Sender Image:</span>
                        <img
                          src={lastStatus.SenderImageURL}
                          width="100px"
                          height="66px"
                          style={{
                            height: '50px',
                            width: '50px',
                            objectFit: 'cover',
                            borderRadius: '50%',
                            margin: '0px 10px',
                          }}
                          border="0"
                        />
                        <a
                          href=""
                          id="idImageViewLink"
                          // onKeyDown={(e) => navigation1(e, 'editIdImageLink', iid.senderIdControl)}
                          className="thumbnail blue-color-txt"
                          onClick={(e) => {
                            e.preventDefault()
                            // showImagePreviewPopup(false)
                          }}
                        >
                          Show
                          <span>
                            <img className={'right'} src={lastStatus.SenderImageURL} />
                          </span>
                        </a>
                      </p>
                    </Item>
                  )}
                </div>
          </div>
          <div
                role="tabpanel"
                hidden={pcTabValue !== 1}
                id={`pc-tabpanel-1`}
                aria-labelledby={`pc-tab-1`}
                className="tab-pc-2 detailed-tabs tab2-view"
              >
                <div className="tab2-container">
                  <div className="cnsn-row misty-dark-bg">
                    <div className="box-padding left">Payment Type</div>
                    <div className="box-padding right">{AllPaymentList[+lrInfo?.PaymentType || 0]}</div>
                  </div>
                  <div className="cnsn-row misty-bg">
                    <div className="box-padding left">Consignment Type</div>
                    <div className="box-padding right">{lrInfo?.SubType} </div>
                  </div>
                  <div className="cnsn-row misty-dark-bg">
                    <div className="box-padding left">Method of Packing</div>
                    <div className="box-padding right">{lrInfo?.MOPName}</div>
                  </div>
                  <div className="cnsn-row misty-bg">
                    <div className="box-padding left">Description</div>
                    <div className="box-padding right">{lrInfo?.Description}</div>
                  </div>
                  <div className="cnsn-row misty-dark-bg">
                    <div className="box-padding left">Cartage Remark</div>
                    <div className="box-padding right">{lrInfo?.CartageRemarks} </div>
                  </div>
                  <div className="cnsn-row misty-dark-bg">
                    <div className="box-padding left">Total Units</div>
                    <div className="box-padding right">
                    {lrInfo?.Quantity}
                    </div>
                  </div>
                  <div className="cnsn-row misty-bg">
                    <div className="box-padding left">Goods Value</div>
                    <div className="box-padding right">{lrInfo?.GoodsValue==0 && loginData.intCompanyID===STA_COMPANY_ID?'As Per Carrier Act':lrInfo?.GoodsValue}</div>
                  </div>
                  {ExemptedGoods || EWayBillNo ? (
                    <div className="cnsn-row misty-dark-bg">
                      <div className="box-padding left"> E-way Bill No</div>
                      <div className="box-padding right" style={{ whiteSpace: 'pre' }}>
                        {EWayBillNo || ExemptedGoods}
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="cnsn-row misty-bg">
                    <div className="box-padding left">Actual Weight</div>
                    <div className="box-padding right">{lrInfo?.ActualWeight}</div>
                  </div>
                  <div className="cnsn-row misty-dark-bg">
                    <div className="box-padding left">Charged Weight</div>
                    <div className="box-padding right">{lrInfo?.ChargedWeight}</div>
                  </div>
  
                  <div className="cnsn-row misty-bg">
                    <div className="box-padding left">Rate</div>
                    <div className="box-padding right">{lrInfo?.Rate+' Per KG'}</div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Freight</div>
                    <div className="box-padding right">
                      {lrInfo?.Freight}
                    </div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Collection Cartage</div>
                    <div className="box-padding right">{lrInfo?.CartageAmount}</div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Pickup Cartage</div>
                    <div className="box-padding right">{lrInfo?.PickupCartage} </div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Misc Cartage</div>
                    <div className="box-padding right">{lrInfo?.CommCartage} </div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Delivery Cartage</div>
                    <div className="box-padding right">{lrInfo?.DeliveryCartage}</div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Hamali and Operator Hamali</div>
                    <div className="box-padding right">
                      {lrInfo?.HamaliCharges}+{lrInfo?.OperatorHamali}={parseInt(lrInfo?.HamaliCharges) + parseInt(lrInfo?.OperatorHamali)}
                    </div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Valuation Charge</div>
                    <div className="box-padding right">{lrInfo?.Valuation}</div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Other Charges</div>
                    <div className="box-padding right">{lrInfo?.OtherCharge}</div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">GST</div>
                    <div className="box-padding right">{lrInfo?.ServiceTax}</div>
                  </div>
                  <div className="cnsn-row">
                    <div className="box-padding left">Total Amount</div>
                    <div className="box-padding right">{lrInfo?.NetAmount}</div>
                  </div>
                </div>
              </div>
        </div>
        <div
              role="tabpanel"
              hidden={lrTabValue !== 1}
              id={`main-tabpanel-1`}
              aria-labelledby={`main-tab-1`}
              className="tab-main-2 details-container"
              style={{ height: 'calc(100% - 260px)', overflowX: 'auto' }}
            >
              <div>
                {LrTrackData?.map((Item, index, { length }) => {
                  return <LrTrackCard data={Item} key={'lrTrackCard' + index} lastIndex={length - 1 === index} />
                })}
              </div>
            </div>
      </>
      
    </Modal>
  )
}

export default LRStatusPopUp
